import { render, staticRenderFns } from "./SurveyDisclaimerDialog.vue?vue&type=template&id=5c7d1e5d&scoped=true"
import script from "./SurveyDisclaimerDialog.vue?vue&type=script&lang=js"
export * from "./SurveyDisclaimerDialog.vue?vue&type=script&lang=js"
import style0 from "./SurveyDisclaimerDialog.vue?vue&type=style&index=0&id=5c7d1e5d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7d1e5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c7d1e5d')) {
      api.createRecord('5c7d1e5d', component.options)
    } else {
      api.reload('5c7d1e5d', component.options)
    }
    module.hot.accept("./SurveyDisclaimerDialog.vue?vue&type=template&id=5c7d1e5d&scoped=true", function () {
      api.rerender('5c7d1e5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/Edit/SurveyDisclaimerDialog.vue"
export default component.exports